import Notification from "../notification/notification";
import togglePreloader from './preloader';

export default new class FormDoc {
    constructor() {
      this.form               = document.querySelector('.form-doc__items');
      this.phoneInput         = document.querySelector('.form-doc__item-phone');
      this.successMsg         = document.querySelector('.form-doc__success-msg');
      this.successMsgSide     = document.querySelector('.form-doc__success-msg__side');     
      this.docsBtn            = document.querySelector('.form-doc__acts-btn');
      this.formDocActs        = document.querySelector('.form-doc__acts');
      this.oneSideAct         = document.querySelector('.form-doc__acts-1side');
      this.actsRadioLabel     = document.querySelectorAll('.form-doc__acts-radio-label');
      this.actsCkeckboxLabel  = document.querySelectorAll('.form-doc__acts-ckeckbox-label');
      this.downloadDocPackBtn = document.querySelector('#GetFilePack');

      if (this.formDocActs) {
        this.docsInputs           = this.formDocActs.querySelectorAll('input')
      }

      this.bind();
    }

    bind() {
      if (this.form)        this.form.addEventListener('submit', this.handleSubmit.bind(this));
      if (this.phoneInput) {
        this.formatPhoneNumberFromDB()
        this.phoneInput.addEventListener('input', this.formatPhoneNumber)
      };
      if (this.docsBtn) {
        this.docsBtn.addEventListener('click', this.handleActs.bind(this));
      }   

      if (this.actsRadioLabel) {
        this.actsRadioLabel.forEach(item => {
            item.addEventListener('click', this.onCheckActs.bind(this))
        })
      }

      if (this.actsCkeckboxLabel) {
        this.actsCkeckboxLabel.forEach(item => {
            item.addEventListener('click', this.showSelectedCheckboxBtn.bind(this))
        })
      }

      if (this.downloadDocPackBtn) {
        this.downloadDocPackBtn.addEventListener('click', this.handleDownloadDocPack.bind(this))
        this.checkDocsPath.bind(this)().then((response) => {
  
          
          if (response && response.status == true) {
            this.downloadDocPackBtn.removeAttribute('hidden')
          }
        })
      }

      if (this.docsInputs) {
        this.docsInputs.forEach((input) => {
          input.addEventListener('click', () => {
            this.docsBtn.classList.remove('disabled')
          })
        })
      }
    }

    handleSubmit(e) {
      e.preventDefault()
      const messages = document.querySelectorAll('.form-doc__success-msg');
      messages.forEach((msg) => msg.innerHTML = '');
      const formData = new FormData(this.form);

      let formDataObj = {};

      for (const [key, value] of formData.entries()) {
          if (key !== 'phone') {
              formDataObj[key] = value
          } else {
              const formattedPN = value.split(' ').join('').split('-').join('');
              formDataObj[key] = formattedPN;
          }
      };

      $.request('FormatSellerDocPack::onSaveFormData', {
        data: formDataObj,
        success: (data) => {
          if (!data.status) {
            this.successMsg.style.color = 'red';
          } else {
            this.successMsg.style.color = 'green';
            this.downloadDocPackBtn.setAttribute('hidden', '')
          }
          this.successMsg.innerHTML = data.message;
        }
      })
    }

    formatPhoneNumberFromDB() {
      if (!this.phoneInput.value) return
      const phoneInput = this.phoneInput.value.replace(/\D/g, '');
      let numb = phoneInput.match(/(\d{0,3})(\d{0,2})(\d{0,3})(\d{0,2})(\d{0,2})/);
      this.phoneInput.value = '+' + numb[1] + ' ' + numb[2] + ' ' + numb[3] + '-' + numb[4] + '-' + numb[5]
    }

    formatPhoneNumber(e) {
      const phoneInput = e.target.value.replace(/\D/g, '');

      let numb = phoneInput.match(/(\d{0,3})(\d{0,2})(\d{0,3})(\d{0,2})(\d{0,2})/);

      const p1 = '+' + numb[1];
      const p2 = p1 + ' ' + numb[2];
      const p3 = p2 + ' ' + numb[3];
      const p4 = p3 + '-' + numb[4];
      const p5 = p4 + '-' + numb[5];

      if (!numb[2]) {
          e.target.value = p1;
      } else if (!numb[3]) {
          e.target.value = p2;
      } else if (!numb[4]) {
          e.target.value = p3;
      } else if (!numb[5]) {
          e.target.value = p4;
      } else {
          e.target.value = p5;
      }

      this.phoneNumber = numb[0];
    }

    handleActs(e) {
       if (this.docsBtn.classList.contains('disabled')) {
        return
      }

      if (this.successMsgSide) {
        this.successMsgSide.innerHTML = '';
      }

      this.docsBtn.classList.add('disabled')
      const messages = document.querySelectorAll('.form-doc__success-msg');
      messages.forEach((msg) => msg.innerHTML = '');

        const _this = this;
        const obButton = $(e.target);
        const iOfferID = obButton.attr('data-offer-id');
        const iArticleID = obButton.attr('data-article-id');
        const iPaymentMethodID = obButton.attr('data-payment-method-id');
        const sType = obButton.attr('data-type');

        _this.obCheckOrder = {
          type: sType,
          payment_method_id: iPaymentMethodID,
          offer_id: iOfferID,
        }

      _this.obRequestOnAdd = {
        cart: [
          {
            offer_id: iOfferID,
            quantity: 1,
            property: {access_element_id: iArticleID, access_element_type: 'Lovata\\GoodNews\\Models\\Article'}
          },
        ],
      };
      _this.obRequestOnCreate = {
        order: {
          type: sType,
          payment_method_id: iPaymentMethodID,
        },
      };

      $.request('Cart::onCheckEventOrder', {
        data: _this.obCheckOrder,
        success(data) {
          if (!data.data.order_id) {
            _this.makeOrder(_this);
          } else {
            const formActsClasses = document.querySelector('.form-doc__acts').classList;

            if (formActsClasses.contains('simpleFormActs')) {
              _this.handleSimpleFormActs(data.data.order_id);

            } else if (formActsClasses.contains('jurFormActs')) {
              _this.handleJurFormActs(data.data.order_id);
            }
          }
        }
      })
    }

    makeOrder(_this)
    {
      $.request('Cart::onSync', {
        data: _this.obRequestOnAdd,
        success(obResponseOnAdd) {

          if (!obResponseOnAdd.X_OCTOBER_REDIRECT && !obResponseOnAdd.status) {
            Notification.showError(obResponseOnAdd && obResponseOnAdd.message);
          }
          // Create order
          $.request('MakeOrder::onCreate', {
            data: _this.obRequestOnCreate,
            success(obResponseonCreate) {
              if (!obResponseonCreate.X_OCTOBER_REDIRECT && !obResponseonCreate.status) {
                Notification.showError(obResponseonCreate && obResponseonCreate.message);
              }
              this.success(obResponseonCreate);
              const formActsClasses = document.querySelector('.form-doc__acts').classList;

              if (formActsClasses.contains('simpleFormActs')) {
                _this.handleSimpleFormActs(obResponseonCreate.data.id);

              } else if (formActsClasses.contains('jurFormActs')) {
                _this.handleJurFormActs(obResponseonCreate.data.id);
              }
            },
          });
        }
      });
    }

    handleSimpleFormActs(order) {
      let data = {act: 1, order: order};

      if (this.oneSideAct.checked) {
          data.act = 1;
      } else {
          data.act = 2;
      }
      togglePreloader(true, this.formDocActs);
      this.sendRequest(data);
    }

    handleJurFormActs(order) {
        let data = {
            act: 1,
            docs_kazn: 0,
            contract: 0,
            order: order
        };

        let inputsNodes = document.querySelectorAll('.form-doc__acts-item>input');
        const checkedData = [...inputsNodes];

        checkedData
            .filter(item => item.checked)
            .forEach(item => {
                if (item.id !== 'two-side') {
                    data[item.name] = 1;
                } else {
                    data[item.name] = 2;
                }
        });

        togglePreloader(true, this.formDocActs);
        this.sendRequest(data);
    }

    sendRequest(data) {
      $.request('FormatSellerDocPack::onFormDocPack', {
        data: data,
        complete: (response) => {
          togglePreloader(false, this.formDocActs);
          if (this.successMsgSide) {
            if (!response.responseJSON.status) {
              this.successMsgSide.style.color = 'red';
              this.docsBtn.classList.remove('disabled')
            } else {
              this.successMsgSide.style.color = 'green';
            }
            this.successMsgSide.innerHTML = response.responseJSON.message;
          }

          if (response.responseJSON.status === true) {

            if (this.downloadDocPackBtn) {
              this.downloadDocPackBtn.removeAttribute('hidden')
            }    
          }
        }
      })
    }

    async checkDocsPath() {
      const offer = this.docsBtn.getAttribute('data-offer-id')
      const formType = this.form.classList.contains('jurForm') ? 'jur_form' : 'simple_form'


      return $.request('FormatSellerDocPack::onGetPath', {
        data: {
          offer_id: offer,
          form: formType
        },
        complete: (response) => 
          {
          if (response.responseJSON.status === true) {
            return response
          } else return false
        }
      })
    }

    handleDownloadDocPack() {
      let path 
      this.checkDocsPath.bind(this)().then((response) => {

        if (response && response.status == true) {
          path = response.data.path
          const link = document.createElement('a');
          link.download = 'архив документов.zip';
          link.href = path;
          link.target= '_blank';
          document.body.append(link);
          link.click();
          link.remove(); 
        }
      })
    }

    onCheckActs(btn) {
        const activeBtn = document.querySelector('.form-doc__acts-radio_active');
        if (activeBtn != btn.target) {
          activeBtn.classList.remove('form-doc__acts-radio_active');
          btn.target.classList.toggle('form-doc__acts-radio_active');
          this.docsBtn.classList.remove('disabled')
        }
    }

    showSelectedCheckboxBtn(btn) {
        btn.target.classList.toggle('form-doc__acts-checkbox_active');
        this.docsBtn.classList.remove('disabled')
    }
}
